export default __webpack_public_path__ + "static/media/haskell.508a3027.svg";